import Announcement from "./announcement";

export default Announcement;
